module.exports = __webpack_public_path__ + "group_buy/groupbuy_step1-31a504649bc4c3e07aecead960d575ff.png";